<template>
    <div class="text-box">
      <p>{{$store.state.prenda}}</p>
    </div>
</template>

<script>
export default {
  name: 'TextBox',
}

</script>